import React, { useState } from 'react';
import { Modal, Button, Upload, Input, message, Select, notification, Card, Space } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { importAddon, showAvailableAddonDetail } from '@/apis/addons';
import { useOne } from '@/hooks';
import { useInvalidate } from "@refinedev/core";
import { useNavigate } from "react-router-dom";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";

import { RESOURCE_TYPE_ADDONS } from '@/resources-def';

const RESOURCE = RESOURCE_TYPE_ADDONS;

const { TextArea } = Input;

export const ImportAddon = ({id}) => {
  const navigate = useResourceNavigate();
  const [fileContent, setFileContent] = useState(null);
  const [versions, setVersions] = useState([]);
  const [existedVersions, setExistedVersions] = useState([]);
  const invalidate = useInvalidate();

  const beforeUpload = (file) => {

    const reader = new FileReader();
    reader.onload = async (e) => {
      const contentObj = JSON.parse(e.target.result);
      setFileContent(contentObj);
      let needConfig = true;
      if(contentObj.id) {
        const data = await showAvailableAddonDetail(contentObj.id);
        if(data?.value?.versions) {
          needConfig = false;
          setVersions(contentObj?.versions.map(item => item.version)); 
          setExistedVersions(data.value.versions.map(version => version.version));
        }
      }
      if(needConfig)
        setVersions(contentObj?.versions.map(item => item.version)); 
    };
    reader.onerror = () => {
      message.error('Read file failed');
    };
    reader.readAsText(file);
    return false; 
  };
  
  const versionsChange = (values) => {
    setVersions(values);
  }

  const handleCancel = () => {
    navigate({ resource: "settings/" + RESOURCE_TYPE_ADDONS, action: "list" });
  };

  const handleImport = async () => {
    if (!fileContent) {
      return;
    }
    const formData = new FormData();
    const content = JSON.stringify({...fileContent, versions: fileContent.versions.filter((version) => versions.indexOf(version.version) != -1)});
    const blob = new Blob([content], { type: 'application/json' })
    formData.append('fileupload', blob, 'upload.json');
    const response = await importAddon(formData);
    clear();
    if (response.status === "OK") {
      navigate({ resource: "settings/" + RESOURCE, action: "list" });
      notification.success({
        description: `Success to import Addon ${response.name}`,
      });
    } else {
      notification.error({
        description: `Failed to import Addon ${response.message}`,
      });
    }
  }

  const clear = () => {
    setFileContent(null);
    setExistedVersions([]);
    setVersions([]);
  }

  return (
    <>
      <Card title={`Export Profile`} 
        style={{ maxWidth: 900, minHeight: 200, marginTop: 0, width: "100%", height: "100%"}}>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between' }}>
        <label style={{ marginRight: 16 }}>Add-on Definition</label>
          <Upload
            showUploadList={false}
            beforeUpload={beforeUpload}
            accept=".txt,.csv,.json,.xml,.log"
            itemRender={() => null}
          >
            <Button icon={<UploadOutlined />}>Browse ...</Button>
          </Upload>
        </div>

        <div style={{ flex: 1, minHeight: 100 }}>
          <TextArea
            value={fileContent != null ? JSON.stringify({...fileContent, versions: fileContent.versions.filter((version) => versions.indexOf(version.version) != -1)}, null, 2) : ""}
            placeholder="Addon Preview"
            readOnly
            rows={20}
            style={{
              height: '100%',
              resize: 'none',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap'
            }}
          />
        </div>
        <Input
          placeholder="Addon Name"
          value={fileContent?.name}
          readOnly={true}
        />
        <Select
          mode="multiple"
          value={versions}
          onChange={versionsChange}
          placeholder="Please select the addon"
          style={{ width: '100%' }}
        >
          {fileContent?.versions?.map((version) => (
            <Option key={version.version} value={version.version}>
              {existedVersions.some(item => item == version.version) ? version.version + " (existed)" : version.version }
            </Option>
          ))}
        </Select>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" onClick={handleImport}>
                    Import
          </Button>
        </div>
        </Space>
      </Card>
    </>
  );
};